import React from 'react';
import './Hero.css'; 
const Hero = () => {
  return (
    <div className="hero">
      <div className="hero-content">
        <h1>Best Treatment for Healthy Life</h1>
        <p>
          Conveniently drive go forward architectures with future-proof growth strategies.
          Energistically supply low-risk high-yield process improvements for mission-critical testing procedures and visual mockups.
        </p>
        <button>Learn More</button>
        <button>Book An Appointment </button>
      </div>
    </div>
  );
};

export default Hero;
